<template>
  <div id="wrap">
    <div id="joinPopup" class="join_st">
      <div class="section">
        <div class="inner flex-center">
          <!-- pc -->
          <!-- <div class="logo_box" v-if="isPc">
            <router-link :to="{ name: 'store' }">
              <span class="ham_logo"></span>
              <span class="an_t univ_logo">
                <img src="@/assets/images/hakji_web_logo.png" alt="" />
              </span>
            </router-link>
          </div> -->
          <!-- mobile -->
          <div class="logo_box mobile">
            <router-link :to="{ name: 'store' }">
              <!-- <span class="ham_logo"></span> -->
              <img src="@/assets/images/hakji_web_logo.png" alt="로고" />
            </router-link>
          </div>
          <div
            class="box_wrap"
            data-detail="id_search"
            :class="{
              idlost: isIdLostPage,
              passlost: isPassLostPage,
              idfound: isIdFoundPage
            }"
          >
            <!-- SLOT CONTENT HERE -->
            <slot />
            <!-- /SLOT -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginWrapper',
  data() {
    return {
      isPc: false,
      isMobile: false
    }
  },
  mounted() {
    this.checkWindowSize()
    window.addEventListener('resize', this.checkWindowSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkWindowSize)
  },
  methods: {
    checkWindowSize() {
      this.isPc = window.innerWidth >= 481
      this.isMobile = window.innerWidth <= 480
    }
  },
  computed: {
    isIdLostPage() {
      return this.$route.path === '/login/id_lost'
    },
    isPassLostPage() {
      return this.$route.path === '/login/password_lost'
    },
    isIdFoundPage() {
      return this.$route.path === '/login/id_found'
    }
  }
}
</script>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.flex-center {
  min-height: 65vh;
  flex-direction: column;
  .logo_box {
    padding: 0px 0px 54px 0px;
    .univ_logo {
      font-size: 30px;
    }
  }
}
#joinPopup {
  position: inherit !important;
}
.box_wrap {
  &.idlost {
    padding: 25px 35px 45px;
  }
  &.passlost {
    padding: 25px 35px 45px;
  }
  &.idfound {
    padding: 25px 35px 45px;
  }
}

@media (max-width: 768px) {
  #wrap {
    width: 100%;
  }
  .flex-center {
    justify-content: flex-start;
  }
}
// #wrap {
//   height: 100%;
//   padding-bottom: 150px;
//   position: inherit !important;
// }

// #joinPopup {
//   position: inherit !important;
// }

// .images_wrap {
//   width: 100vw;
// }
// @media (max-width: 480px) {
.flex-center {
  .logo_box {
    width: 100%;
    padding: 0;
    margin-bottom: 28px;
    display: none;
  }
}
.univ_logo {
  img {
    image-rendering: auto;
  }
}
// }
@media (max-width: 480px) {
  .logo_box.mobile {
    display: block;
    > a {
      display: block;
      width: 160px;
      height: 31px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .flex-center {
    min-height: 100vh;
  }
}
</style>
